<template>
  <div class="form-field-container dual-component-container">
    <div class="dual-content">
      <div class="left-component">
        <slot name="left"></slot>
      </div>
      <div class="right-component">
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormDualComponent',
  props: {
    label: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    showRequired: {
      type: Boolean,
      default: true
    },
  }
}
</script>

<style scoped>
.dual-component-container {
  display: flex;
  align-items: center;
  background-color: #FFF;
  padding: 10px 20px;
  margin-bottom: 10px;
  border-radius: 4px;
}

.dual-content {
  display: flex;
  flex: 1;
  align-items: center;
  margin-left: 10px;
}

.left-component {
  margin-right: 20px;
  min-width: 150px;
}

.left-component :deep(> *) {
  margin: 0;
  padding: 0;
}

.right-component {
  flex: 0 0 auto;
  margin-left: 10px;
}
</style>
